{
  "name": "asset-hub",
  "version": "4.3.11a",
  "angular-cli": {},
  "scripts": {
    "build-client": "ng build --configuration local && npm run move-files",
    "build-client-ci": "ng build --aot --source-map --configuration production --deploy-url=js/ && npm run move-files",
    "build-client-docker": "ng build --configuration=local80 --deploy-url=js/ && npm run move-files",
    "build-client-dev": "ng build --aot --configuration=dev --deploy-url=js/ && npm run move-files",
    "build-client-staging": "ng build --aot --source-map --configuration staging --deploy-url=js/ && npm run move-files",
    "build-client-prod": "ng build --aot --source-map --configuration production --deploy-url=js/ && npm run move-files",
    "build-server": "rimraf server/build && tsc -p server/tsconfig.json",
    "start-server": "node server/build/server/src/server.js",
    "test-server": "npm run build-server && cross-env NODE_ENV=test nyc --reporter=html mocha server/build/server/src/**/*.spec.js --exit",
    "test-server-codeship": "cross-env NODE_ENV=test nyc --reporter=html mocha server/build/server/src/**/*.spec.js --exit",
    "watch-server": "nodemon --watch server/src --watch shared --watch server/.env --exec ts-node-dev --pretty --project server/tsconfig.json server/src/server.ts",
    "watch-server-debug": "node watch-server.js --debug",
    "watch-server-pm2": "node watch-server.js",
    "tail-logs": "pm2 logs",
    "migrate": "npm run build-server && knex migrate:latest --env local && cross-env NODE_ENV=test knex migrate:latest --env test",
    "rollback": "npm run build-server && knex migrate:rollback --env local && cross-env NODE_ENV=test knex migrate:rollback --env test",
    "migrate-codeship": "cross-env NODE_ENV=test knex migrate:latest --env codeship",
    "migrate-travis": "cross-env NODE_ENV=test knex migrate:latest --env travis",
    "migrate-aws": "knex migrate:latest --env aws",
    "migrate-jenkins": "knex migrate:latest --env jenkins",
    "migrate-local": "npm run build-server && knex migrate:latest --env local",
    "migrate-local-rollback": "npm run build-server && knex migrate:rollback --env local",
    "migrate-test": "npm run build-server && cross-env NODE_ENV=test knex migrate:latest --env test",
    "migrate-test-rollback": "npm run build-server && cross-env NODE_ENV=test knex migrate:rollback --env test",
    "ng": "ng",
    "start": "node server/bootstrap.js",
    "serve": "ng serve --proxy-config proxy.conf.json -c=local",
    "serve80": "ng serve --proxy-config proxy.conf.json --configuration=local80",
    "serve-penguin": "ng serve --proxy-config proxy.conf.json --configuration=penguin --host 0.0.0.0 --public-host penguin.linux.test",
    "serve-dev-locally": "ng serve --proxy-config proxy.conf.json --aot --configuration=dev",
    "lint": "eslint \"src/**/*.ts\" --project src/tsconfig.json --type-check && eslint \"e2e/**/*.ts\" --project e2e/tsconfig.json --type-check",
    "test": "NODE_OPTIONS=--max_old_space_size=4096  ng test -c=test --watch=false",
    "test-watch": "ng test --watch -c=test",
    "test-watch-more-ram": "NODE_OPTIONS=--max_old_space_size=4096 npm run test-watch",
    "test-watch-chrome": "ng test --watch -c=test --browsers Chrome",
    "test-coverage": "ng test -cc true -sm true",
    "pree2e": "webdriver-manager update --standalone false --gecko false",
    "move-files": "mkdir dist/js && find dist -maxdepth 1 -mindepth 1 -not -name index.html -not -name favicon.ico -not -name assets -not -name js -exec mv '{}' dist/js \\;",
    "ncu": "ncu",
    "watch": "concurrently -n \"ng,server\" -c \"blue,green\" \"npm run serve80\" \"npm run watch-server\"",
    "watch-the-throne": "concurrently -n \"ng,server\" -c \"blue,green\" \"npm run serve\" \"npm run watch-server\"",
    "watch-penguin": "concurrently -n \"ng,server\" -c \"blue,green\" \"npm run serve-penguin\" \"npm run watch-server\""
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.9",
    "@angular/cdk": "^20.2.12",
    "@angular/common": "^20.3.9",
    "@angular/compiler": "^20.3.9",
    "@angular/core": "^20.3.9",
    "@angular/forms": "^20.3.9",
    "@angular/material": "^20.2.12",
    "@angular/platform-browser": "^20.3.9",
    "@angular/platform-browser-dynamic": "^20.3.9",
    "@angular/platform-server": "^20.3.9",
    "@angular/router": "^20.3.9",
    "@aws-sdk/client-lambda": "^3.461.0",
    "@aws-sdk/client-s3": "^3.461.0",
    "@aws-sdk/client-sns": "^3.461.0",
    "@aws-sdk/cloudfront-signer": "^3.451.0",
    "@aws-sdk/s3-request-presigner": "^3.461.0",
    "@hapi/boom": "^10.0.1",
    "@hapi/code": "^9.0.3",
    "@hapi/crumb": "^9.0.1",
    "@hapi/hapi": "^21.4.4",
    "@hapi/inert": "^7.1.0",
    "@ng-idle/core": "^13.0.0",
    "@ngrx/effects": "^20.1.0",
    "@ngrx/store": "^20.1.0",
    "@ngrx/store-devtools": "^20.1.0",
    "@primeng/themes": "^20.3.0",
    "@primeuix/themes": "^1.2.5",
    "@sendgrid/helpers": "^7.7.0",
    "@sendgrid/mail": "^8.1.6",
    "@sentry/browser": "^9.47.1",
    "@sentry/node": "^9.47.1",
    "@types/jsonwebtoken": "^8.5.9",
    "accounting": "^0.4.1",
    "are-we-there-yet": "^1.1.5",
    "big.js": "^7.0.1",
    "cookie": "^1.0.2",
    "core-js": "^3.33.3",
    "csv-writer": "^1.6.0",
    "currency-formatter": "^1.5.5",
    "dotenv": "^4.0.0",
    "file-saver": "^1.3.8",
    "handlebars": "^4.7.7",
    "hapi-pino": "^13.0.0",
    "ioredis": "^5.8.2",
    "joi": "^17.11.0",
    "jsonwebtoken": "^9.0.2",
    "knex": "^2.5.1",
    "lodash": "^4.17.21",
    "lodash.difference": "^4.5.0",
    "moment": "^2.29.4",
    "ngx-device-detector": "^10.1.0",
    "pg": "^8.16.3",
    "pino": "^10.1.0",
    "pino-pretty": "^13.1.3",
    "pkce-challenge": "^3.0.0",
    "pluralize": "^8.0.0",
    "pm2": "^6.0.13",
    "primeicons": "^7.0.0",
    "primeng": "^20.3.0",
    "pug": "^3.0.2",
    "@zxing/browser": "^0.1.4",
    "@zxing/library": "^0.21.3",
    "redis": "^5.9.0",
    "request-promise": "^4.2.5",
    "reselect": "^5.1.1",
    "rxjs": "^6.5.4",
    "rxjs-compat": "^6.5.4",
    "sendgrid-rest": "^2.6.1",
    "sharp": "^0.34.4",
    "ssf": "^0.11.2",
    "tslib": "^2.8.1",
    "typeorm": "^0.3.27",
    "uuid": "^13.0.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "^20.0.0",
    "@angular/build": "^20.3.8",
    "@angular/cli": "^20.3.8",
    "@angular/compiler-cli": "^20.3.9",
    "@angular/language-service": "^20.3.9",
    "@sentry/types": "^7.119.0",
    "@types/big.js": "0.0.32",
    "@types/bookshelf": "^0.13.0",
    "@types/faker": "^4.1.11",
    "@types/file-saver": "^2.0.7",
    "@types/hapi__crumb": "^7.3.7",
    "@types/ioredis": "^4.28.10",
    "@types/jasmine": "~3.8.0",
    "@types/lodash": "^4.14.149",
    "@types/mocha": "^9.0.0",
    "@types/node": "^22.19.11",
    "@types/pluralize": "0.0.29",
    "@types/request-promise": "4.1.36",
    "@typescript-eslint/eslint-plugin": "^6.13.1",
    "@typescript-eslint/parser": "^6.13.1",
    "baseline-browser-mapping": "^2.9.19",
    "codelyzer": "^0.0.28",
    "concurrently": "^8.2.1",
    "cross-env": "^10.1.0",
    "eslint": "^8.54.0",
    "faker": "^4.1.0",
    "hammerjs": "^2.0.8",
    "jasmine-core": "~3.8.0",
    "jasmine-marbles": "^0.3.0",
    "jasmine-spec-reporter": "^5.0.1",
    "karma": "^6.3.20",
    "karma-chrome-launcher": "^3.1.0",
    "karma-cli": "^2.0.0",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-diff-reporter": "^2.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "karma-mocha-reporter": "^2.2.5",
    "karma-webpack": "^5.0.0",
    "material-design-icons": "^3.0.1",
    "mkdirp": "^0.5.4",
    "mocha": "^10.2.0",
    "mockery": "^2.0.0",
    "ngrx-store-freeze": "^0.2.4",
    "nodemon": "^3.0.1",
    "npm-check-updates": "^16.14.4",
    "nyc": "^15.1.0",
    "sass": "^1.94.0",
    "sinon": "^2.3.8",
    "sos-factory-girl": "^4.2.1",
    "stream-to-promise": "^2.2.0",
    "svg-sprite": "^2.0.2",
    "ts-node": "^10.9.2",
    "ts-node-dev": "^2.0.0",
    "typescript": "~5.8.3",
    "webpack": "^5.88.2"
  }
}
